function setSelectedMenu() {
  const url = location.href;

  document.querySelectorAll('.gh-head-navigation-primary > *').forEach((element) => {
    element.classList.remove('selected');
  });

  if (url.includes('insight')) {
    document.querySelector('a[href="/insight"]').classList.add('selected');

    return;
  }

  document.querySelector('a[href="/"]').classList.add('selected');
}

document.addEventListener('DOMContentLoaded', function () {
  setSelectedMenu();
});